/**
 * Footer H3 to P Converter
 * Converts h3 elements to p.wpb_accordion_header in the footer
 * Per SEO: converte gli h3 DOPO che JS Composer ha inizializzato l'accordion
 */
(function () {
    'use strict';

    function convertH3ToP() {
        // Verifica se jQuery è disponibile
        if (typeof jQuery === 'undefined') {
            return;
        }

        // Find all footer sections
        const footerSections = [
            '#footer-primary',
            '#footer-secondary',
            '#footer-tertiary',
            '#footer-bottom',
            'footer#footer'
        ];

        footerSections.forEach(function (selector) {
            const footerSection = document.querySelector(selector);
            if (!footerSection) return;

            // Trova tutti gli h3, anche dentro gli accordion
            const h3Elements = footerSection.querySelectorAll('h3');

            h3Elements.forEach(function (h3) {
                // Create new p element
                const pElement = document.createElement('p');

                // Copy all classes from h3 to p
                const classes = h3.className.split(' ').filter(cls => cls.trim() !== '');

                // Aggiungi wpb_accordion_header se non c'è
                if (!classes.includes('wpb_accordion_header')) {
                    classes.push('wpb_accordion_header');
                }

                pElement.className = classes.join(' ');

                // Copy all attributes from h3 to p (IMPORTANTE per mantenere funzionalità accordion)
                Array.from(h3.attributes).forEach(function (attr) {
                    if (attr.name !== 'class') {
                        pElement.setAttribute(attr.name, attr.value);
                    }
                });

                // Copy innerHTML from h3 to p
                pElement.innerHTML = h3.innerHTML;

                // Replace h3 with p
                h3.parentNode.replaceChild(pElement, h3);
            });

            // Se abbiamo convertito h3 dentro accordion, re-inizializza con il selettore corretto
            const accordions = footerSection.querySelectorAll('.wpb_accordion');
            if (accordions.length > 0) {
                accordions.forEach(function (accordion) {
                    const $accordion = jQuery(accordion);
                    const $wrapper = $accordion.find('.wpb_accordion_wrapper');

                    // Se l'accordion è già inizializzato
                    if ($wrapper.hasClass('ui-accordion')) {
                        try {
                            const activeTab = $accordion.data('active-tab');
                            const active = !isNaN(activeTab) && parseInt(activeTab) > 0 ? parseInt(activeTab) - 1 : false;
                            const collapsible = active === false || $accordion.data('collapsible') === 'yes';

                            // Re-inizializza con il selettore corretto per p invece di h3
                            $wrapper.accordion('destroy').accordion({
                                header: "> div > p.wpb_accordion_header", // Usa p invece di h3
                                autoHeight: false,
                                heightStyle: "content",
                                active: active,
                                collapsible: collapsible,
                                navigation: true
                            });
                        } catch (e) {
                            console.warn('Errore re-inizializzazione accordion:', e);
                        }
                    }
                });
            }
        });
    }

    // Aspetta che JS Composer abbia inizializzato gli accordion
    if (typeof jQuery !== 'undefined') {
        jQuery(document).ready(function () {
            // Aspetta che vc_accordionBehaviour() sia eseguito
            setTimeout(convertH3ToP, 200);
            setTimeout(convertH3ToP, 500);
        });
    } else {
        document.addEventListener('DOMContentLoaded', function () {
            // Se jQuery non è ancora caricato, aspetta
            const checkJQuery = setInterval(function () {
                if (typeof jQuery !== 'undefined') {
                    clearInterval(checkJQuery);
                    setTimeout(convertH3ToP, 200);
                    setTimeout(convertH3ToP, 500);
                }
            }, 100);
        });
    }
})();
